import React from 'react';
import MiniLoader from 'components/MiniLoader';

const withMiniLoader = (
  WrappedComponent,
  isLoading,
  additionalLoaderStyles
) => {
  return function (props) {
    return (
      <>
        {isLoading ? (
          <MiniLoader additionalStyles={additionalLoaderStyles} />
        ) : (
          <WrappedComponent {...props} />
        )}
      </>
    );
  };
};

export default withMiniLoader;
